import React from "react";

import UsersView from "../modules/Users";

export default function Users() {
  return <UsersView />;
}
